import { Component, ReactNode } from "react";
import { connect }              from "react-redux";
import GetAccount               from "../../application/usecase/authentication/GetAccount";
import Account                  from "../../domain/account/Account";
import { ResKaState }           from "../../index";

interface Props {
  account: Account;
  getAccount: GetAccount;
}

class GetAccountContainer extends Component<Props> {
  componentDidMount(): void {
    this.props.getAccount.execute();
  }

  render(): ReactNode {
    return null;
  }
}

const mapStateToProps = (state: ResKaState) => ({
  account: state.account,
});

const mapDispatchToProps = (dispatch) => ({
  getAccount: new GetAccount(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(GetAccountContainer);